import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { usePwaStore } from './stores/pwa';
import { useWhiteLabelStore } from '@/stores/whiteLabel';
import './styles/main.css';
// CSS oficial do PDF.js — necessário pra textLayer (seleção de texto em PDF)
// posicionar spans corretamente. Sem isso, seleção não funciona.
import 'pdfjs-dist/web/pdf_viewer.css';

/**
 * NextPay Reader — Sprint 1 (2026-05-07)
 *
 * Bootstrap do app Vue. PWA é registrado pelo plugin Vite em build de produção.
 */
const app = createApp(App);

const pinia = createPinia();
app.use(pinia);
app.use(router);

// Inicializa o PWA store — listeners globais para `beforeinstallprompt` e
// `appinstalled`. Importante chamar antes do mount() para não perder o
// primeiro `beforeinstallprompt` (que pode disparar logo no carregamento).
usePwaStore().init();

// Whitelabel no boot, nao por tela.
//
// loadConfig() so era chamado em Login.vue e ForgotPassword.vue. Quem ja
// tinha sessao aberta — o caso normal de uma PWA instalada — entrava direto na
// biblioteca sem passar por nenhuma das duas, e as variaveis de cor do
// vendedor nunca eram aplicadas. Aqui roda uma vez, para qualquer rota.
//
// Nao bloqueia o mount: o :root de main.css ja garante a paleta padrao, entao
// a tela nasce pintada e so troca de cor se o vendedor tiver customizacao.
useWhiteLabelStore()
  .loadConfig()
  .catch(() => {
    /* offline ou API fora: segue com a paleta padrao do :root */
  });

app.mount('#app');
